export default function (coordinates) {
    if (coordinates.length < 2) {
        return []
    } else {
        let pnt1 = coordinates[0];
        let pnt2 = coordinates[1];
        let xmin = Math.min(pnt1[0], pnt2[0]);
        let xmax = Math.max(pnt1[0], pnt2[0]);
        let ymin = Math.min(pnt1[1], pnt2[1]);
        let ymax = Math.max(pnt1[1], pnt2[1]);
        let tl = [xmin, ymax];
        let tr = [xmax, ymax];
        let br = [xmax, ymin];
        let bl = [xmin, ymin];
        return [[tl, tr, br, bl, tl]];
    }
}